let _url = process.env.VUE_APP_ROOT_SERVICE || "https://envoy-console-many.unicop.ht-sandbox.com"

const ENVOY_LIST: any = {
  // 加纳rapidcedi 测试
  "https://h5-platform-many.rapidcedi.ht-sandbox.com": {
    apiUrl: "https://envoy-console-many.rapidcedi.ht-sandbox.com",
    env: 'test',
    country: 'ghana'
  },
  // 加纳rapidcedi 正式
  "https://h5-platform-many.rapidcedi.com": {
    apiUrl: "https://envoy-console-many.rapidcedi.com",
    env: 'prod',
    country: 'ghana'
  },
  // 哥伦比亚unicop 测试
  "https://h5-platform-many.unicop.ht-sandbox.com": {
    apiUrl: "https://envoy-console-many.unicop.ht-sandbox.com",
    env: 'test',
    country: 'co'
  },
  // 哥伦比亚unicop 正式
  "https://h5-platform-many.unicop.co": {
    apiUrl: "https://envoy-console-many.unicop.co",
    env: 'prod',
    country: 'co'
  },
  // 墨西哥mifectivo 测试
  "https://h5-platform-many.mifectivo.ht-sandbox.com": {
    apiUrl: "https://envoy-console-many.mifectivo.ht-sandbox.com",
    env: 'test',
    country: 'mx'
  },
  // 墨西哥yumi 测试
  "https://h5-platform.yumicash.ht-sandbox.com": {
    apiUrl: "https://envoy-console.yumicash.ht-sandbox.com",
    env: 'test',
    country: 'mx'
  },
  // 墨西哥yumi 测试
  "https://h5-platform.yumicash.com": {
    apiUrl: "https://envoy.yumicash.com",
    env: 'prod',
    country: 'mx'
  },
  // 墨西哥yumi 正式
  "https://h5-platform-many.mifectivo.com": {
    apiUrl: "https://envoy-console-many.mifectivo.com",
    env: 'prod',
    country: 'mx'
  },
  // 秘鲁solyacash 测试
  "https://h5-platform-many.solyacash.ht-sandbox.com": {
    apiUrl: "https://envoy-console-many.solyacash.ht-sandbox.com",
    env: 'test',
    country: 'peru'
  },
  // 菲律宾 测试
  "https://h5-platform.cashola.ht-sandbox.com": {
    apiUrl: "https://envoy-console.cashola.ht-sandbox.com",
    env: 'test',
    country: 'ph'
  },
  // 菲律宾 测试
  "https://h5-platform.casholaapp.com": {
    apiUrl: "https://envoy-console.casholaapp.com",
    env: 'prod',
    country: 'ph'
  },
  // 秘鲁solyacash 正式
  "https://h5-platform-many.solyacash.com": {
    apiUrl: "https://envoy-console-many.solyacash.com",
    env: 'prod',
    country: 'peru'
  },
  // 坦桑onepesa 测试
  "https://h5-platform-many.onepesa.ht-sandbox.com": {
    apiUrl: "https://envoy-console-many.onepesa.ht-sandbox.com",
    env: 'test',
    country: 'tanzania'
  },
  // 坦桑onepesa 正式
  "https://h5-platform-many.onepesa.co": {
    apiUrl: "https://envoy-console-many.onepesa.co",
    env: 'prod',
    country: 'tanzania'
  },
  // 坦桑onepesa 测试
  "https://h5-platform.onepesa.ht-sandbox.com": {
    apiUrl: "https://envoy-console.onepesa.ht-sandbox.com",
    env: 'test',
    country: 'tanzania'
  },
  // 坦桑onepesa 正式
  "https://h5-platform.onepesa.co": {
    apiUrl: "https://envoy-console.onepesa.co",
    env: 'prod',
    country: 'tanzania'
  },

}


export const API_SERVICE: string = ENVOY_LIST[location.origin]?.apiUrl
  ? ENVOY_LIST[location.origin]?.apiUrl 
  : _url;
export const API_COUNTRY: string = ENVOY_LIST[location.origin]?.country || 'co'
